import createNewCharacterSpellEntry from '../helpers/createNewCharacterSpellEntry'
import trackSpellChanges from '../helpers/trackSpellChanges.js'

import store from '../store/index'
//-------------------
// process add spell
//-------------------
export default function processAddSpell({
  parms = {},
  changed_spells = [],
  original_spells = [],
  character = null,
} = {}) {
  console.log('--------------------------------------')
  console.log('IN processAddSpell parms = ', parms)
  //-----------
  // get parms
  //-----------
  const track_spell = parms.payload ?? {} // includes temp id for tracking
  console.log('SPELL TO ADD = ', track_spell)
  const character_id = character?.id ?? null
  //-------------------------------
  // update tracking with new spell
  //-------------------------------
  console.log('2. off to track spell changes')
  changed_spells = trackSpellChanges({
    spell: track_spell,
    original_spells,
    changed_spells,
    character_id,
  })

  //------------------
  // get static spell
  //------------------
  const static_spell_id = parms.payload.spell ?? null // static spell id
  console.log('1. off to get static spell')
  let static_spell = static_spell_id
    ? store.getters['characters/getStaticSpellById'](static_spell_id)
    : null

  if (!static_spell) {
    console.error('*** processAddSpell - No static spell found for id:', static_spell_id)
  }
  console.log('##### static_spell = ', static_spell)
  //----------------------------------
  // create new character spell entry
  //----------------------------------
  console.log('3. off to create new character spell entry')
  let new_spell = createNewCharacterSpellEntry({
    id: track_spell.id, // temp id used for tracking
    static_spell: static_spell, // unpacked in helper
    mag: track_spell.mag,
    character_item: track_spell.character_item,
    character_rune: track_spell.character_rune,
    character: track_spell.character,
    casting_rune_name: parms.casting_rune_name, // for tablespells source display
    item_name: parms.item_name, // for tablespells source display
    source_name: parms.source_name, // for tablespells source display
  })

  //-------------------------------
  // add spell to character spells
  //-------------------------------
  if (!character) {
    console.error('*** processAddSpell - character is null; cannot attach spell')
  } else {
    if (!Array.isArray(character.spells)) {
      character.spells = []
    }
    character.spells.push(new_spell)
  }
  console.log('NEW SPELL ADDED TO CHARACTER = ', new_spell)

  //------------------------------------------------------
  // decide whether to create casting skill (i.e sorcery)
  //------------------------------------------------------
  const spellType = String(new_spell?.type ?? static_spell?.type ?? '').toLowerCase()
  const isRuneLinkedSpell = Boolean(track_spell.character_rune)
  const casting_skill_applicable =
    Boolean(static_spell?.casting_skill_applicable) && spellType === 'sorcery' && !isRuneLinkedSpell

  //------------------------
  // return mutated objects
  //------------------------
  console.log('completed processAddSpell new spell = ', new_spell)
  return {
    changed_spells,
    new_spell,
    character,
    static_spell,
    casting_skill_applicable,
  }
}
